// extracted by css-extract-rspack-plugin
export default {"container":"IssueTypeIndicator-module__container__qkF3B6P"};